import FlexPane from './_flex-pane.js'
import ScrollPane from './_scroll-pane.js'
import AbsolutePane from './_absolute-pane.js'
import Button from './_button.js'
import Image from './_image.js'

export default {
  name: 'ButtonScrollPane',
  values: {
    useButtonScrolling: true,
    _mobile_useButtonScrolling: false,
    scrollFactor: 0.4,
    scrollItemIntoView: true,
    scrollItemIntoViewBehavior: 'center',
    scrollPaneContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          minWidth: '0px',
          padding: '0 10px 0 0',
          _mobile_padding: '0',
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        nativeScroll: false,
        mouseDragScroll: false,
        display: 'flex',
      },
    },
    leftScrollButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: '0px',
          left: '0px',
          height: '100%',
          zIndex: 1,
        },
      },
    },
    leftScrollButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minWidth: '24px',
          },
          disabled: {
            opacity: 0.5,
            cursor: 'auto',
          },
        },
      },
    },
    leftScrollButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'chevron-left',
        style: {
          minWidth: '10px',
        },
      },
    },
    rightScrollButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: '0px',
          right: '0px',
          height: '100%',
          zIndex: 1,
        },
      },
    },
    rightScrollButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minWidth: '24px',
          },
          disabled: {
            opacity: 0.5,
            cursor: 'auto',
          },
        },
      },
    },
    rightScrollButtonIcon: {
      configSet: Image,
      configValues: {
        src: 'chevron-right',
        style: {
          minWidth: '10px',
        },
      },
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _mobile_padding: '0 8px',
          flexShrink: 0,
          minHeight: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
